import React, { useEffect, useState, useRef } from "react";
import { Table, Input} from "antd";
import { getApmcApplicationDetails,  } from "../../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { OverlayTrigger,Tooltip } from "react-bootstrap";





const MenuAPMC: React.FC = () => {
 
 
  const [applicationData, setApplicationData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(5); // Default limit
  const [totalItems, setTotalItems] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchQuery, setSearchQuery] = useState<string>("");
 const type= "scheme";
  

const language = useSelector((state:any)=>state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const navigate = useNavigate();
  const debounceTimer = useRef<ReturnType<typeof setTimeout> | null>(null);



  

  const columns = [
    {
      title: language.application_id,
      dataIndex: "applicationId",
      render: (text: string) => (
        <h6 className="fw-medium">
          <Link to="#">{text}</Link>
        </h6>
      ),
    },
    { title: language.apmc_name, dataIndex: "apmc" },
    { title: language.district, dataIndex: "district" },
{
  title: "Scheme",
  dataIndex: "schem",
  render: (text: string) => (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id={`tooltip-scheme-${text}`}>{text}</Tooltip>}
    >
      <div
        style={{
          maxWidth: 200,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          cursor: "pointer",
        }}
      >
        {text}
      </div>
    </OverlayTrigger>
  ),
},

    {
      title: language.applied_date,
      dataIndex: "appliedDate",
      render: (date: string) => {
        if (!date) return "NA";
        const d = new Date(date);
        return isNaN(d.getTime()) ? "NA" : d.toLocaleDateString("en-GB");
      }, // "DD/MM/YY"
    },
     {
      title: language.application_status,
      dataIndex: "status",
      render: (status: string) => {
        const statusMapping: Record<string, string> = {
          permanentReject: "Permanent reject",
          approvedUnsigned: "Approve Unsigned",
          reject: "Raised Query",
          pending:"Pending",
          resubmission: "Resubmission",
          draft:"Draft",
          approve:"Approved"

        };

        return <span>{statusMapping[status] || status}</span>;
      },
    },
    // 
{
  title: language.action,
  dataIndex: "applicationId",
  render: (text: string, record: any) => {
    const handleNavigate = () => {
      navigate("/schemes-query", {
        state: {
          applicationId: record.applicationId,
          id: record.schemeId,
        },
      });
    };

    // only show button if status is "reject" then it will be resubmission
    // if (record.status !== "reject") return null;

    return (
      <h6 className="fw-medium">
        <button
          className={`rounded text-white px-4 py-2 ${
            record.action ? "bg-info" : "bg-primary"
          }`}
          onClick={handleNavigate}
        >
          {record.action ? language.review : language.view}
        </button>
      </h6>
    );
  },
}

   
  ];



  const fetchApplication = async (
    page: number,
    searchApplicationById: string = "",
    limit: number,
    status?: string
  ) => {
    setLoading(true);
    try {
      // If status is empty string or undefined/null, use 'all'
      const statusToSend = !status ? 'all' : status;
      const appdata = await getApmcApplicationDetails(
        statusToSend,
        token,
        page,
        searchApplicationById,
        limit,
        type
      );
      //.log("Fetched Data:", appdata);

      if (appdata?.success) {
        setApplicationData(appdata.data || []);
        setTotalItems(appdata.totalCount || 0);
      }
    } catch (error) {
      //.error("Error fetching applications:", error);
    } finally {
      setLoading(false);
    }
  };




  const handleSearch = (value: string) => {
    setSearchQuery(value);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      fetchApplication(1, value, limit , ""); 
      setCurrentPage(1); 
    }, 500); 
  };


  useEffect(() => {
    fetchApplication(currentPage, searchQuery, limit, ""); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage,limit,searchQuery]);

  return (
    <>
        <div className="page-wrapper">
                <div className="content">
                    {/* Breadcrumb */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Application List</h2>
                        </div>
                    </div>
                    {/* /Breadcrumb */}

                    {/* Performance Indicator list */}
                    <div className="card">
                     

                        <div className="card-body p-0">
      <div className="table-top-data">
        <div className="row p-3">
          <div className="col-sm-12 d-flex justify-content-end">
        

            <Input
              placeholder="Search Application Id..."
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              allowClear
            />
          </div>
        </div>
      </div>

    
      <Table
        className="table datanew dataTable no-footer"
        // rowSelection={Selections ? rowSelection : undefined}
        columns={columns}
        rowHoverable={false}
         rowKey={"applicationId"}
        dataSource={applicationData}
        loading={loading}
        pagination={{
          locale: { items_per_page: "" },
          nextIcon: <i className="ti ti-chevron-right" />,
          prevIcon: <i className="ti ti-chevron-left" />,
          pageSize: limit, 
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30"],
          current: currentPage,
          total: totalItems,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total} entries`,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize); 
          },
        }}
      />
       </div>
                      
                    </div>
                    {/* /Performance Indicator list */}
                </div>
            </div>
    </>
  );
};

export default MenuAPMC;
